export default __webpack_public_path__ + "static/media/face_3_4.0bb6867b.png";